import React from 'react';

import { styled, colors, fontSmoothing } from '~/styles';
import Wrapper from '~/components/layout/Wrapper';

import { useSelector } from '~/redux';
import { localStorageKeys } from '~/utils/localStorageKeys';

import ExternalLink from '~/components/common/ExternalLink';
import config from '~/config';

const StyledTopPanel = styled.div`
  line-height: 25px;
  background: ${colors.darkblue};
  color: ${colors.white};
  font-size: 11.5px;
  font-weight: 500;
  vertical-align: middle;
  letter-spacing: normal;
  white-space: nowrap;
  ${fontSmoothing};
  position: relative;
  z-index: 2;

  a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const PageTopPanel = () => {
  const entryParams = useSelector((state) => state.entryParams);

  return (
    <StyledTopPanel>
      <Wrapper>
        <div>
          {/* We can be assured this URL is safe against XSS attacks: https://reactjs.org/docs/introducing-jsx.html#jsx-prevents-injection-attacks */}
          {/* <ExternalLink target='_self' href={ entryParams.refURL ? entryParams.refURL.toString() : (localStorage.getItem(localStorageKeys.refURL) || '') } >GO TO REVANCE<strong>U</strong> | LEARNING PORTAL</ExternalLink> */}
          <ExternalLink target='_self' href={ config.revanceUPortalLink.URL } >GO TO REVANCE<strong>U</strong> | LEARNING PORTAL</ExternalLink>
        </div>
      </Wrapper>
    </StyledTopPanel>
  );
};

export default PageTopPanel;



// WEBPACK FOOTER //
// ./src/components/layout/header/PageTopPanel.tsx